import { useState, useEffect } from "react";

const getLocalValue = (key, initValue) => {
    if (typeof window === "undefined") {
        return initValue instanceof Function ? initValue() : initValue;
    }

    try {
        const raw = localStorage.getItem(key);
        if (raw === null || raw === "undefined") {
            return initValue instanceof Function ? initValue() : initValue;
        }

        return JSON.parse(raw);
    } catch {
        return initValue instanceof Function ? initValue() : initValue;
    }
}

const useLocalStorage = (key, initValue) => {

    const [value, setValue] = useState(() => {
        return getLocalValue(key, initValue);
    });

    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch {
            // Ignore storage write failures (private mode/storage disabled)
        }
    }, [key, value])

    return [value, setValue]
};

export default useLocalStorage